import { cx } from '../lib/cx';

export interface ProgressBarProps {
  value: number;
  max?: number;
  label?: string;
  valueLabel?: string;
  className?: string;
  tone?: 'accent' | 'success' | 'warning' | 'danger';
}

const TONE = {
  accent: 'bg-accent',
  success: 'bg-success',
  warning: 'bg-warning',
  danger: 'bg-danger',
};

export function ProgressBar({
  value,
  max = 100,
  label,
  valueLabel,
  className,
  tone = 'accent',
}: ProgressBarProps) {
  const safeMax = max > 0 ? max : 1;
  const pct = Math.max(0, Math.min(100, (value / safeMax) * 100));
  return (
    <div className={cx('flex flex-col gap-2', className)}>
      {(label || valueLabel) && (
        <div className="flex items-baseline justify-between gap-3">
          {label && <span className="text-[13px] text-ink-muted">{label}</span>}
          {valueLabel && <span className="text-[13px] text-ink">{valueLabel}</span>}
        </div>
      )}
      <div
        role="progressbar"
        aria-valuenow={Math.round(value)}
        aria-valuemin={0}
        aria-valuemax={Math.round(safeMax)}
        aria-label={label}
        className="h-1.5 w-full overflow-hidden rounded-pill bg-bg-alt"
      >
        <div
          className={cx('h-full rounded-pill transition-[width] duration-300', TONE[tone])}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
